import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import * as React from 'react';

interface StatusLozengeProps {
  label: string;
  status?:
    | 'deactivated'
    | 'deleted'
    | 'disabled'
    | 'expired'
    | 'review-required'
    | 'processed'
    | 'verified'
    | 'unverified'
    | 'inprogress'
    | 'whitelisted'
    | 'payment-issue'
    | 'payment-error'
    | 'cancellation-pending'
    | 'active-verified'
    | 'refunded'
    | 'archived'
    | 'billed-elsewhere'
    | 'add-on'
    | 'upcoming'
    | 'internal-use-license'
    | 'advanced-trial';
  isBold?: boolean;
  appearance?: ThemeAppearance;
}

export const StatusLozenge = ({ isBold = true, label, status, appearance }: StatusLozengeProps) => (
  <span className={`entity-status entity-status-${status}`} data-testid={`status-lozenge-${status}`}>
    <Lozenge isBold={isBold} appearance={appearance}>
      {label}
    </Lozenge>
  </span>
);

export const UnverifiedLozenge = () => <StatusLozenge label="Unverified" status="unverified" />;

export const VerifiedLozenge = () => <StatusLozenge label="Verified" status="verified" />;

export const DeletedLozenge = () => <StatusLozenge label="Deleted" status="deleted" />;

export const DeletionPendingLozenge = () => <StatusLozenge label="Deletion Pending" status="deleted" />;

export const DeactivatedLozenge = () => <StatusLozenge label="Deactivated" status="deactivated" />;

export const AnnualLozenge = () => <StatusLozenge label="Annual" status="inprogress" appearance="inprogress" />;

export const ExpiredLozenge = () => <StatusLozenge label="Expired" status="expired" />;

export const Sev0Lozenge = () => <StatusLozenge label="SEV-0" status="deleted" />;

export const RequiresReviewLozenge = () => <StatusLozenge label="Requires Review" status="review-required" />;

export const ProcessedLozenge = () => <StatusLozenge label="Processed" status="processed" />;

export const PartnerLozenge = () => <StatusLozenge label="Partner" status="inprogress" />;

export const SuspendedLozenge = () => <StatusLozenge label="Inactive" status="expired" />;

export const WhitelistedLozenge = () => <StatusLozenge label="whitelisted" status="inprogress" />;

export const InactiveLozenge = ({ label = 'Inactive' }: { label?: string }) => (
  <StatusLozenge label={label} status="deleted" />
);

export const RefundedLozenge = () => (
  <StatusLozenge label="REFUNDED" status="refunded" appearance="removed" isBold={false} />
);

export const ActiveLozenge = () => <StatusLozenge label="Active" status="active-verified" />;

export const TrialLozenge = () => <StatusLozenge label="Trial" appearance="inprogress" isBold={false} />;

export const UpgradePremiumTrial = () => <StatusLozenge label="Premium Trial" appearance="inprogress" isBold={false} />;

export const UpgradeAdvancedTrial = () => (
  <StatusLozenge label="Advanced Trial" appearance="inprogress" isBold={false} status="advanced-trial" />
);

export const PaymentErrorLozenge = () => (
  <StatusLozenge isBold={false} label="Payment error" status="payment-error" appearance="removed"></StatusLozenge>
);

export const SandboxLozenge = () => (
  <StatusLozenge label="Sandbox" status="inprogress" appearance="inprogress" isBold={false} />
);

export const AppLozenge = () => (
  <StatusLozenge label="App" status="inprogress" appearance="inprogress" isBold={false} />
);

export const PricingPlanLozenge = ({ plan }: { plan: string }) => (
  <StatusLozenge label={plan} status="review-required" />
);

export const DraftLozenge = () => <StatusLozenge label="Draft" status="unverified" />;

export const DefaultLozenge = ({ label }: { label: string }) => <StatusLozenge label={label} isBold={false} />;

export const CancellationPendingLozenge = () => (
  <StatusLozenge
    isBold={false}
    label="Cancellation pending"
    status="cancellation-pending"
    appearance="moved"
  ></StatusLozenge>
);

export const ArchivedLozenge = () => (
  <StatusLozenge label="Archived" status="archived" appearance="moved" isBold={false} />
);

export const BilledElsewhereLozenge = () => (
  <StatusLozenge label="Billed elsewhere" status="billed-elsewhere" appearance="moved" isBold={false} />
);

export const AddOnLozenge = () => {
  return <StatusLozenge label="add-on" status="add-on" appearance="new" isBold={false} />;
};

export const FutureDatedLozenge = () => {
  return <StatusLozenge label="upcoming" status="upcoming" appearance="new" isBold={false} />;
};

export const InternalUsageLicensesLozenge = () => {
  return (
    <StatusLozenge label="Internal Use License" status="internal-use-license" appearance="inprogress" isBold={false} />
  );
};
